import { render, staticRenderFns } from "./wait.vue?vue&type=template&id=d3ace430&scoped=true&"
import script from "./wait.vue?vue&type=script&lang=js&"
export * from "./wait.vue?vue&type=script&lang=js&"
import style0 from "./wait.vue?vue&type=style&index=0&id=d3ace430&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3ace430",
  null
  
)

export default component.exports